<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="920px"
    top="6vh"
    append-to-body
    destroy-on-close
    @close="close"
  >
    <MaterialPanel
      ref="panel"
      mode="pick"
      :multiple="multiple"
      :selected-urls="selectedUrls"
    />
    <div slot="footer" class="picker-footer">
      <span class="picker-footer__tip">
        {{ multiple ? '可多选，确定后追加到已选图片' : '点击缩略图选择一张图片' }}
      </span>
      <el-button size="small" @click="close">取消</el-button>
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MaterialPanel from './MaterialPanel.vue'

export default {
  name: 'MaterialPicker',
  components: { MaterialPanel },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // 当前已选地址，用于回显勾选
    value: {
      type: [String, Array],
      default: ''
    },
    title: {
      type: String,
      default: '素材库'
    }
  },
  computed: {
    selectedUrls() {
      if (Array.isArray(this.value)) {
        return this.value.filter(Boolean)
      }
      return this.value ? [this.value] : []
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    confirm() {
      const panel = this.$refs.panel
      const assets = panel ? panel.getSelection() : []
      const urls = assets.map((item) => item.url).filter(Boolean)
      if (!urls.length) {
        this.$message.warning('请先选择素材')
        return
      }
      this.$emit('confirm', this.multiple ? urls : urls[0])
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.picker-footer {
  display: flex;
  align-items: center;
  gap: 10px;

  &__tip {
    flex: 1;
    text-align: left;
    font-size: 12px;
    color: var(--app-text-secondary);
  }
}
</style>
